import React from 'react';
import { Link } from 'react-router-dom';
import { useIsTif } from '../../../../../helpers/user';
import CustomWrapper from '../../customWrapper';
import { CustomIcon } from 'datastake-daf/dist/components';

const AdditionalCRAFTRequirements = ({ t = (s) => s, canEdit = false, body }) => {
  const { isTif } = useIsTif();
  const link = isTif ? "/app/tif/view/kyc/user/" : "/app/cadd/view/kyc/user/";

  return (
    <CustomWrapper
      t={t}
      body={body}
      type="header"
      descIcon={<CustomIcon name="Warning" width={17} height={16} color="#FA541C" />}
      formDescription={(
        <>
          {t('The KYC report indicates that the organisation is not a mining operator. As such, CRAFT requirements do not apply.')}
          {' '}
          <Link to={link}>
            {t('To update the KYC click here.')}
          </Link>
        </>
      )}
      className="no-body-header"
    />
  );
}

export default AdditionalCRAFTRequirements;
